<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 450px" class="yl-flex flex_between">
                    <Input placeholder="搜索员工姓名" v-model="name" style="width: 300px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
                </div>

            </div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
                </RadioGroup>
            </div>


            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row,index }" slot="action">
                        <div style="color: #0092FF; cursor: pointer;" :data-index="index" @click.stop="save">编辑保存</div>
                    </template>
                    <template slot-scope="{ row,index }" slot="assessment">
                        <Input @on-change="salaryChange($event,index)" v-model="datas[index].assessment" style="width: 60px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="attendance">
                        <Input @on-change="salaryChange($event,index)" v-model="datas[index].attendance" style="width: 60px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="tax">
                        <Input @on-change="salaryChange($event,index)" v-model="datas[index].tax" style="width: 60px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="security">
                        <Input @on-change="salaryChange($event,index)" v-model="datas[index].security" style="width: 60px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="accumulation_fund">
                        <Input @on-change="salaryChange($event,index)" v-model="datas[index].accumulation_fund" style="width: 60px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="other_fund">
                        <Input @on-change="salaryChange($event,index)" v-model="datas[index].other_fund" style="width: 60px"/>
                    </template>
                </Table>
            </div>
        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
	import {getSalaryList, saveSalary} from "../../api/finance.js";

	export default {
        name: "Generate",
        components: {},

        data() {
            return {
                name: '',
                timePeriod: '6',
                timePeriodDate: [],
                datas: [
                ],
                columns: [

                    {
                        "title": "所属部门",
                        "key": "department_name",
                        align: 'center'
                    },
                    {
                        "title": "员工姓名",
                        "key": "name",
                        align: 'center'
                    },
                    {
                        "title": "月份",
                        "key": "month",
                        align: 'center'
                    },
                    {
                        "title": "基本工资",
                        "key": "base",
                        align: 'center'
                    },
                    {
                        "title": "业绩提成",
                        "key": "achievement",
                        align: 'center'
                    },
                    {
                        "title": "考核奖励",
                        "slot": "assessment",
                        align: 'center'
                    },
                    {
                        "title": "考勤",
                        "slot": "attendance",
                        align: 'center'
                    },
                    {
                        "title": "应发工资",
                        "key": "gross_pay",
                        align: 'center'
                    },
                    {
                        "title": "个税",
                        "slot": "tax",
                        align: 'center'
                    },
                    {
                        "title": "社保代缴",
                        "slot": "security",
                        align: 'center'
                    },
                    {
                        "title": "公积金代缴",
                        "slot": "accumulation_fund",
                        align: 'center'
                    },
                    {
                        "title": "其他扣款",
                        "slot": "other_fund",
                        align: 'center'
                    },
                    {
                        "title": "实发工资金额",
                        "key": "net_pay",
                        align: 'center',
                        width: '120'
                    },
                    {
                        "title": "操作",
                        "slot": "action",
                        align: 'center'
                    },
                ]
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
        methods: {

            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            initSearch() {

            },
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					timePeriod: that.timePeriod,
					name: that.name
				};
				let res = await getSalaryList(that, data);
				if (res.code == 1) {
					that.datas = res.data.list;
				}
			},
            save(e) {
                let that = this;
                let index = e.currentTarget.dataset.index;
                that.throttle(async function () {
                    let data = {
                        token: that.token,
                        timePeriod: that.timePeriod,
                        data: that.datas[index]
                    };
                    let res = await saveSalary(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                    }
                }, 500)
            },
            salaryChange(e, index) {
                let that = this;
                that.datas[index].gross_pay = parseFloat(that.datas[index].base) + parseFloat(that.datas[index].achievement) + parseFloat(that.datas[index].assessment) + parseFloat(that.datas[index].attendance);
                that.datas[index].net_pay = parseFloat(that.datas[index].gross_pay) - parseFloat(that.datas[index].security) - parseFloat(that.datas[index].accumulation_fund) - parseFloat(that.datas[index].other_fund);
            }
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
